<template>
  <div class="user-purchases">
    <el-table
      :data="purchases"
      :default-sort="{prop: 'purchasedAt', order: 'descending'}"
      border>
      <el-table-column label="User Purchases">
        <el-table-column
          prop="name"
          label="name"
          sortable>
        </el-table-column>
        <el-table-column
          prop="store_id"
          label="storeID"
          :formatter="storeIdFmt"
          sortable>
        </el-table-column>
        <el-table-column
          prop="pay_method"
          label="pay method"
          width="140"
          :formatter="payMethodFmt"
          sortable>
        </el-table-column>
        <el-table-column
          prop="voucher"
          label="voucher"
          width="160"
          sortable>
        </el-table-column>        
        <el-table-column
          prop="purchasedAt"
          label="purchased"
          width="160"
          :formatter="purchasedAtFmt"
          sortable>
        </el-table-column>
        <el-table-column
          prop="activatedAt"
          label="activated"
          width="160"
          :formatter="activatedAtFmt"
          sortable>
        </el-table-column>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import moment from 'moment'

export default {
  props: ['purchases'],
  methods: {
    purchasedAtFmt (row, col) {
      return moment(row.purchasedAt).format('lll')
    },
    activatedAtFmt (row, col) {
      return moment(row.activatedAt).format('lll')
    },
    storeIdFmt (row, col) {
      return row.store_id.replace('com.motocompano', '..')
    },
    payMethodFmt (row, col) {
      if (row.pay_method === null) {
        return row.pay_method
      } else {
        if (row.pay_method.includes('itunes') || (row.pay_method.includes('playstore'))) {
          return 'app/' + row.pay_method
        } else {
          return row.pay_method
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/users/UserPurchases.vue